export default __webpack_public_path__ + "static/media/57t.11ea8308.jpg";